import React, { useContext } from 'react';
import { UIContext } from 'context/ui';

import s from './TabsItem.scss';

interface IProps {
  children: React.ReactNode;
  active: boolean;
  id: string;
  onClick?: (args: any) => void;
}

export const TabsItem = ({ children, id, active, onClick = () => null }: IProps) => {

  const { isDesktop } = useContext<any>(UIContext);

  if (!isDesktop) {
    return <option value={id} className={s('tabsItem')}>{children}</option>;
  }

  return (
    <button className={s('tabsItem', { active })} onClick={() => { onClick(id); }}>
      {children}
    </button>
  );
};
